import {alpha, Divider, Grid, List, ListItem, ListItemButton, Skeleton} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {RootState, useAppSelector} from "../../../store";
import {getRandomNumber} from "../../../util/utils";
import {FC} from "react";
import {getRandomCategoriesArray} from "../../../store/category/Helper";
import Box from "@mui/material/Box";
import Badge from "../../shared/badge/Badge";
import {useTheme} from "@mui/material/styles";
import ScrollFader from "../../shared/scroll-fader/ScrollFader";

interface Props {
    selectedCategory: string
    handleChangeCategory: (id: string) => void
}

const CategorySidebar: FC<Props> = (props) => {
    const {t, i18n} = useTranslation()
    const categories = useAppSelector((state: RootState) => state.categoryReducer.items)
    const categoriesLoading = useAppSelector((state: RootState) => state.categoryReducer.fetchCategoriesLoading)
    const categoriesArray = categoriesLoading ? getRandomCategoriesArray() : categories
    const theme = useTheme()

    return (
        <Box>
            <Typography variant='h5' color="primary" fontWeight={600} mt="4px">{t('category')}</Typography>
            <Divider sx={{
                height: "2px",
                width: '100%',
                backgroundColor: alpha(theme.palette.primary.main, .5),
                mt: 2.5,
                mb: 1
            }}/>
            <ScrollFader faderSize={70} deps={[categoriesArray]}>
                <List sx={{maxHeight: "53vh"}}>
                    {categoriesArray.map((category) => (
                        <ListItemButton key={category.id}
                                        disabled={category.count === 0}
                                        sx={{p: 0, cursor: category.count !== 0 ? 'cursor' : 'default'}}
                                        selected={category.id === props.selectedCategory}
                                        onClick={() => category.count !== 0 ? props.handleChangeCategory(category.id) : {}}>
                            <ListItem sx={{py: `12px !important`}}>
                                <Grid container justifyContent="space-between" alignContent="center" flexWrap="nowrap"
                                      gap={1}>
                                    <Typography variant="body1" color="primary"
                                                fontWeight={category.id === "all" ? 600 : undefined}>
                                        {categoriesLoading ?
                                            <Skeleton animation='wave' width={`${getRandomNumber(80, 150)}px`}/> :
                                            category[`name_${i18n.language}`]}
                                    </Typography>
                                    <Box sx={{alignSelf: 'center'}}>
                                        {categoriesLoading ?
                                            <Skeleton variant='circular' animation='pulse' width='20px'/> :
                                            <Badge
                                                content={(category.count !== 0 || category.id === 'all') ? category.count : t('coming_soon')}/>}
                                    </Box>
                                </Grid>
                            </ListItem>
                        </ListItemButton>
                    ))}
                </List>
            </ScrollFader>
        </Box>
    )
}

export default CategorySidebar
